import { Component } from '@angular/core';
import { LoaderServiceService } from '../loader-service.service';

@Component({
  selector: 'app-spinner-loader',
  templateUrl: './spinner-loader.component.html',
  styleUrl: './spinner-loader.component.scss'
})
export class SpinnerLoaderComponent {

  isLoading = false;

  constructor(private loaderService: LoaderServiceService) {}

  ngOnInit() {
    this.loaderService.isLoading$.subscribe(status => {
      this.isLoading = status;
    });
  }
}
